import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import { isDefined } from '@stillmandigital/common';
import { formatDate } from '@angular/common';
import { defaultLocaleId } from '@shared/localization/localization.constants';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(duration);

type DateParamType = Date | dayjs.Dayjs | string | number | undefined;

export type SupportedTimezone = 'America/New_York' | 'UTC';

export const defaultTimezone: SupportedTimezone = 'America/New_York';

export const supportedTimezones: SupportedTimezone[] = ['America/New_York', 'UTC'];

export const FORMAT_DATE_TIME_WITH_MS = 'YYYY-MM-DDTHH:mm:ss.SSS';

export function convertFromUTC(
  value: DateParamType,
  timezone: SupportedTimezone,
): string {
  return dayjs.utc(value).tz(timezone).format(FORMAT_DATE_TIME_WITH_MS);
}

export function formatToLocaleDateString(
  value: DateParamType,
  timezone: SupportedTimezone,
  format = 'medium',
) {
  if (!isDefined(value)) {
    return '';
  }

  const date = convertFromUTC(value, timezone);

  return formatDate(date, format, defaultLocaleId);
}
